import { render, staticRenderFns } from "./story_banner.vue?vue&type=template&id=d07a4168&"
import script from "./story_banner.vue?vue&type=script&lang=js&"
export * from "./story_banner.vue?vue&type=script&lang=js&"
import style0 from "./story_banner.vue?vue&type=style&index=0&id=d07a4168&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports